import { render, staticRenderFns } from "./assignTemplate.vue?vue&type=template&id=6cf25d6e&scoped=true&"
import script from "./assignTemplate.vue?vue&type=script&lang=js&"
export * from "./assignTemplate.vue?vue&type=script&lang=js&"
import style0 from "./assignTemplate.vue?vue&type=style&index=0&id=6cf25d6e&prod&scoped=true&lang=css&"
import style1 from "./assignTemplate.vue?vue&type=style&index=1&id=6cf25d6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf25d6e",
  null
  
)

export default component.exports